<div class="user-management-container" [ngClass]="{'dialogMode': dialog}">
  <!-- Header Section -->
  <div class="header-section">
    <!-- Stats Cards -->
    <div class="stats-row">
      @if (totalSeats > 0) {
        <div class="stat-card">
          <div class="stat-label">Total CRM Seats</div>
          <div class="stat-value">{{totalSeats}}</div>
        </div>
      }
      <div class="stat-card">
        <div class="stat-label">Active Users</div>
        <div class="stat-value">{{totalActiveUsers}}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Inactive Users</div>
        <div class="stat-value">{{totalInactiveUsers}}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Total Users</div>
        <div class="stat-value">{{totalUsers}}</div>
      </div>
    </div>

    @if (appIssueUserCount > 0) {
      <div class="app-health-banner" (click)="goToAppStatus()">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>{{appIssueUserCount}} {{appIssueUserCount === 1 ? 'user needs' : 'users need'}} app configuration attention</span>
        <button class="btn-app-status">
          App Status <span class="btn-count">{{appIssueUserCount}}</span>
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    }

    <!-- Search Bar -->
    <div class="search-wrapper ml-auto">
      <input
        class="search-input"
        name="quickSearch"
        type="search"
        [(ngModel)]="searchValue"
        placeholder="Search users by name, email, or phone..."
        aria-label="Search users">
      <i class="bi bi-search search-icon"></i>
    </div>
  </div>

  <!-- User Cards Grid -->
  <div class="users-grid">
    @for (member of fetchedUserMemberships | membershipfilter:searchValue; track member.id) {
      <div class="user-card" [ngClass]="{
        'user-pending': member.notYetJoined === true,
        'user-inactive': member.userAccountStatus === 'INACTIVE'
      }">

        <!-- Card Body -->
        <div class="card-body">
          <!-- Avatar and Basic Info -->
          <div class="user-header">
            <div class="avatar-wrapper">
              <app-profile-image
                classInput="user-avatar"
                [displayName]="member.user?.name"
                [userId]="member.user?.id"
                [imageFilePath]="member.user?.profilePictureUrl">
              </app-profile-image>
              @if (member.notYetJoined) {
                <span class="status-dot status-pending"></span>
              }
              @if (member.userAccountStatus === 'INACTIVE') {
                <span class="status-dot status-inactive"></span>
              }
            </div>

            <div class="user-details">
              <div class="name-row">
                <h3 class="user-name">{{ member?.user?.name || 'Unnamed User' }}</h3>
                <span class="user-role">{{ member.authorizationLevel | formatEnum }}</span>
                @if (member.isReadOnlyAccess) {
                  <span class="user-role" title="This user can view this workspace but cannot make changes">Read only</span>
                }
                @if (getUserHealth(member); as health) {
                  @if (health.status === 'not-installed') {
                    <span class="health-pill-sm hp-not-installed" title="App not installed" (click)="goToAppStatus(); $event.stopPropagation()">
                      <i class="bi bi-phone-fill"></i> No App
                    </span>
                  } @else if (getActionableCount(health); as count) {
                    <span class="health-pill-sm" [ngClass]="hasCriticalIssue(health) ? 'hp-critical' : 'hp-warning'" [title]="getActionableTitle(health)" (click)="goToAppStatus(); $event.stopPropagation()">
                      <i class="bi" [ngClass]="hasCriticalIssue(health) ? 'bi-exclamation-octagon-fill' : 'bi-exclamation-triangle-fill'"></i>
                      {{count}} {{count === 1 ? 'Issue' : 'Issues'}}
                    </span>
                  }
                }
              </div>

              <!-- Status Labels -->
              @if (member.notYetJoined && member.userAccountStatus !== 'INACTIVE') {
                <span class="status-label pending">Invite Sent</span>
              }
              @if (member.userAccountStatus === 'INACTIVE') {
                <span class="status-label inactive">Deactivated</span>
              }
              @if (member.userAccountStatus === 'ACTIVE' && member.excludedFromSalesmaxSupport) {
                <span class="status-label support-excluded"
                  matTooltip="Use the ⋮ menu to re-include this user in support">
                  Excluded from support
                </span>
              }

              <!-- Geofence assignment -->
              @if (canAdministerGeofences()) {
                @if (geofenceNameFor(member); as geofenceName) {
                  <span class="status-label geofence" [matTooltip]="geofenceTooltip(member)">
                    <i class="bi bi-geo-alt"></i> {{ geofenceName }}
                  </span>
                } @else if (isGeofenceFailClosed(member)) {
                  <span class="status-label geofence-alert"
                    matTooltip="This member has restricted actions but no geofence, so those actions are denied. Use the ⋮ menu to fix it.">
                    <i class="bi bi-exclamation-triangle"></i> Geofence missing
                  </span>
                }
              }

              <!-- Contact Info -->
              <div class="contact-list">
                @if (member?.user?.registeredNumber) {
                  <div class="contact-detail">
                    <i class="bi bi-telephone"></i>
                    <span>{{ member.user.registeredNumber }}</span>
                  </div>
                }
                @if (member?.user?.registeredEmail) {
                  <div class="contact-detail">
                    <i class="bi bi-envelope"></i>
                    <span>{{ member.user.registeredEmail }}</span>
                  </div>
                }
              </div>

              <div class="added-date">
                Added {{ member.createdAt | formatDateTime }}
              </div>

              <!-- Custom Attributes -->
              @if (member.customMemberAttributes) {
                <app-render-custom-contact-properties
                  [accountMembership]="member">
                </app-render-custom-contact-properties>
              }
            </div>
          </div>
        </div>

        <!-- Action Buttons (Show on Hover/Touch) -->
        <div class="card-actions">
          <button class="btn-action" (click)="goToUserPhoneCallClicked(member)" title="Call">
            <i class="bi bi-telephone"></i>
            <span>Call</span>
          </button>

          @if (member.userAccountStatus === 'ACTIVE') {
            <button class="btn-action" (click)="startChatWithUser(member)" title="Chat">
              <i class="bi bi-chat-left"></i>
              <span>Chat</span>
            </button>
          }

          @if (!dialog) {
            <button class="btn-action" (click)="modifyEmployeeButtonClicked(member)" title="Edit">
              <i class="bi bi-pencil"></i>
              <span>Edit</span>
            </button>
          }

          <button class="btn-action" (click)="setRoster(member)" title="Roster">
            <i class="bi bi-calendar3"></i>
            <span>Roster</span>
          </button>

          @if (getActionableCount(getUserHealth(member)); as issueCount) {
            <button class="btn-action btn-issues" [matMenuTriggerFor]="issueMenu" title="View app issues">
              <i class="bi bi-exclamation-triangle"></i>
              <span>Issues ({{issueCount}})</span>
            </button>
            <mat-menu #issueMenu="matMenu" class="issue-popover-menu">
              <div class="issue-popover-header" mat-menu-item disabled>
                <strong>App Issues</strong>
              </div>
              @for (issue of getPotentialActionableIssues(getUserHealth(member)); track issue.id) {
                <button mat-menu-item class="issue-popover-item" (click)="goToAppStatus()">
                  <i class="bi" [ngClass]="issue.severity === 'critical' ? 'bi-exclamation-octagon-fill text-danger' : 'bi-exclamation-triangle-fill text-warning'"></i>
                  <div class="issue-popover-text">
                    <span class="issue-popover-title">{{issue.title}}</span>
                    <span class="issue-popover-fix">{{issue.fix}}</span>
                  </div>
                </button>
              }
            </mat-menu>
          }

          <!-- Deactivate/Activate Button -->
          @if (member.userAccountStatus === 'ACTIVE') {
            <button
              class="btn-action btn-deactivate"
              [swal]="{
                title: 'Make User Inactive?',
                html: '<p>This will disable their access to the CRM and stop them from receiving leads. You can reactivate them later.</p>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Make Inactive',
                cancelButtonText: 'Cancel'
              }"
              (confirm)="changeActiveStatus(member, 'INACTIVE')"
              title="Deactivate User">
              <i class="bi bi-pause-circle"></i>
              <span>Deactivate</span>
            </button>
          }

          @if (member.userAccountStatus === 'INACTIVE') {
            <button
              class="btn-action btn-activate"
              (click)="changeActiveStatus(member, 'ACTIVE')"
              title="Activate User">
              <i class="bi bi-play-circle"></i>
              <span>Activate</span>
            </button>
          }

          <!-- More Menu -->
          <button class="btn-action btn-more" [matMenuTriggerFor]="moreMenu" title="More Options">
            <i class="bi bi-three-dots-vertical"></i>
          </button>
        </div>

        <!-- More Actions Menu -->
        <mat-menu #moreMenu="matMenu">
          @if (!dialog && canManageReadOnlyAccess(member)) {
            <button mat-menu-item (click)="toggleReadOnlyAccess(member)"
              [disabled]="readOnlyUpdatesPending.has(member.id)">
              <i class="bi bi-lock"></i>
              <span>{{ member.isReadOnlyAccess ? 'Restore Write Access' : 'Make Read Only' }}</span>
            </button>
          }
          @if (!dialog && activeAccount && (activeAccount.authorizationLevel === 'SUPERADMIN' || activeAccount.authorizationLevel === 'ADMIN' || activeAccount.userId === member.userId)) {
            <button mat-menu-item
              [swal]="{
                title: 'Change User Name',
                input: 'text',
                inputValue: member.user?.name || '',
                text: 'This will update the user name across all workspaces',
                showCancelButton: true,
                confirmButtonText: 'Update Name',
                inputAttributes: { placeholder: 'Enter new name' },
                inputValidator: validateInput
              }"
              (confirm)="modifyName($event, member)">
              <i class="bi bi-person"></i>
              <span>Change Name</span>
            </button>
          }

          @if (!dialog && canAdministerGeofences()) {
            <button mat-menu-item (click)="openGeofencePanel(member)">
              <i class="bi bi-geo-alt"></i>
              <span>{{ geofenceNameFor(member) ? 'Change Geofence' : 'Assign Geofence' }}</span>
            </button>
          }

          @if (member.userAccountStatus === 'ACTIVE' && member.excludedFromSalesmaxSupport) {
            <button mat-menu-item (click)="reIncludeInSupport(member)">
              <i class="bi bi-chat-left-dots"></i>
              <span>Re-include in Support Chat</span>
            </button>
          }

          @if (member.userAccountStatus === 'REQUESTED' && !dialog) {
            <button mat-menu-item
              [swal]="{
                title: 'Approve User?',
                text: 'User will become part of the team account',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, Approve'
              }"
              (confirm)="approveUser(member)">
              <i class="bi bi-check-circle"></i>
              <span>Approve Addition</span>
            </button>

            <button mat-menu-item
              [swal]="{
                title: 'Disapprove User?',
                text: 'User will not be included in the team account',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Disapprove'
              }"
              (confirm)="disapproveUser(member)">
              <i class="bi bi-x-circle"></i>
              <span>Disapprove Addition</span>
            </button>
          }

          @if (member.userAccountStatus === 'NUMBER CHANGED' && !dialog) {
            <button mat-menu-item
              [swal]="{
                title: 'Approve Number Change?',
                text: 'User has changed their registered number. Verify authenticity before approving.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Approve'
              }"
              (confirm)="approveUser(member)">
              <i class="bi bi-telephone"></i>
              <span>Approve Number Change</span>
            </button>
          }

          <mat-divider></mat-divider>

          <button mat-menu-item class="menu-danger"
            [swal]="{
              title: 'Permanently Remove User?',
              html: '<p><strong>Warning: This action cannot be undone!</strong></p><p>This will permanently delete the user and all their data.</p>',
              icon: 'error',
              showCancelButton: true,
              confirmButtonText: 'Yes, Permanently Remove',
              cancelButtonText: 'Cancel'
            }"
            (confirm)="removeUser(member)">
            <i class="bi bi-trash"></i>
            <span>Permanently Remove</span>
          </button>
        </mat-menu>
      </div>
    }
  </div>
</div>
